import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import { FormGroup } from 'reactstrap'

const GroupTitle = styled.h4`
  text-align: left;
  font-size: 22px;
  line-height: 26px;
  font-weight: 500;
  margin-top: 20px;
`

export default function Text({ name }) {
  const [{ text }] = useStoreState(state => [
    state.form.getByName(name),
  ])
  return (
    <FormGroup className="col-xs-12">
      <GroupTitle htmlFor={`text-${name}`}>{text}</GroupTitle>
    </FormGroup>
  )
}
